import { useSelector } from 'react-redux';
import { useNonBrandPlatformsQuery } from 'src/context/api/non-branded/api';
import { useCurrentWorkspace } from 'src/context/reducers/app-settings';
import { RootState } from 'src/context/store';
import { fDate } from 'src/utils/format-time';

/**
 * Platforms with Non Brand traffic over the page range (Google / Bing), undefined until loaded. The workspace list
 * of the header comes from Brand data, so it may hold a platform the Non Brand data does not have.
 */
export function useNonBrandPlatforms(enabled = true): string[] | undefined {
  const workspace = useCurrentWorkspace();
  const start = useSelector((state: RootState) => state.filters.start);
  const end = useSelector((state: RootState) => state.filters.end);
  const { data } = useNonBrandPlatformsQuery(
    { workspace_id: workspace?.id as number, start_date: fDate(start, 'yyyy-MM-dd'), end_date: fDate(end, 'yyyy-MM-dd') },
    { skip: !enabled || !workspace?.id }
  );
  return data?.platforms;
}
